export const aboutData = {
  brandName: '打屁股视频大全',
  brandIntro: '打屁股视频大全是一个专注于视频内容聚合与推荐的精选平台。我们致力于为用户提供高质量、多元化的视频内容合集，涵盖亲子教育、影视经典、搞笑娱乐、历史文化、动漫游戏、社会热点等多个领域。自成立以来，我们始终坚持「精选优质内容，传递正向价值」的核心理念，以严谨的筛选标准和用心的内容编排，为每一位用户打造舒适愉悦的浏览体验。',
  mission: '我们的使命是让每一位用户都能在这里找到感兴趣的视频内容，通过精心筛选和分类整理，帮助用户高效获取优质视频资源，在娱乐中获得知识，在放松中收获成长。',
  values: [
    { title: '精选优质', desc: '每一篇内容都经过人工筛选，确保质量上乘、信息准确。我们宁缺毋滥，只为呈现最好的内容。' },
    { title: '多元包容', desc: '内容覆盖多个领域和视角，尊重不同观点和文化，打造包容开放的内容社区。' },
    { title: '正向价值', desc: '所有内容都传递积极、健康的价值观，让用户在娱乐中获得正能量。' },
    { title: '用户至上', desc: '以用户需求为导向，持续优化内容推荐和浏览体验，让每一位用户都能满意而归。' },
  ],
  reputation: [
    { name: '李明华', role: '资深媒体人', comment: '内容质量很高，分类清晰，是我日常获取优质视频资讯的首选平台。推荐给身边很多朋友了。', rating: 5 },
    { name: '张晓雨', role: '教育工作者', comment: '亲子教育板块做得特别好，很多内容对我的教学工作都有启发。希望能持续产出更多优质内容。', rating: 5 },
    { name: '王建国', role: '互联网从业者', comment: '网站设计简洁大方，浏览体验很流畅。内容的原创性和深度都超出预期，会持续关注。', rating: 5 },
    { name: '陈思思', role: '大学生', comment: '动漫和搞笑板块太有意思了！课余时间就喜欢泡在这里，每次都有新发现。', rating: 4 },
    { name: '刘大力', role: '自由职业者', comment: '作为忠实用户已经一年多了，见证了平台内容的不断丰富。期待未来能推出更多互动功能。', rating: 5 },
  ],
  contact: {
    email: 'contact@dapiguvideo.com',
    wechat: 'dapigu_video',
    weibo: '@打屁股视频大全',
    address: '北京市朝阳区望京SOHO T3-A座 1208室',
    phone: '400-888-6666',
    workHours: '周一至周五 9:00 - 18:00',
  },
  stats: [
    { label: '精选内容', value: '5000+' },
    { label: '内容分类', value: '6' },
    { label: '日均访问', value: '10万+' },
    { label: '用户好评', value: '98%' },
  ],
  faqs: [
    { question: '网站的内容来源是什么？', answer: '我们的内容由专业编辑团队精心筛选和编排，部分内容来源于公开的视频平台，部分为原创内容。所有内容均经过严格的审核流程，确保信息准确性和内容质量。' },
    { question: '如何找到我感兴趣的内容？', answer: '您可以通过首页的分类导航进入对应的内容板块，也可以使用搜索功能（即将上线）直接查找感兴趣的关键词。每个分类页面都提供详细的内容列表和筛选功能。' },
    { question: '网站会定期更新内容吗？', answer: '是的，我们保持每日更新，确保用户能够及时获取最新的优质视频内容。首页的「最新更新」板块会实时展示最新添加的内容。' },
    { question: '我可以在手机上访问吗？', answer: '当然可以！我们的网站采用了响应式设计，在手机、平板、电脑等不同设备上都能获得良好的浏览体验。' },
    { question: '如何联系我们？', answer: '您可以通过邮箱、微信、微博等多种方式联系我们。具体联系方式请查看「关于我们」页面的联系信息板块。我们会在工作时间内尽快回复您的留言。' },
  ],
};